import {call, delay, put, select} from 'redux-saga/effects';
import {push as redirectTo} from 'redux-first-history';
import {LOGIN_URL} from 'paths';

import {
    applicationTokenError,
    applicationTokenSet,
    authenticationError,
    newAccessToken,
    receiveApplicationToken
} from 'modules/authentication/actions';
import {loginStates} from 'modules/authentication/constants';
import {handleLoginSuccess, handleLogout} from 'modules/authentication/sagas/login';
import {handleOAuth2Redirect} from 'modules/authentication/sagas/oauth2';
import {authRedirectSelector, loginStateSelector} from 'modules/authentication/selectors';
import {getApiToken, rememberLocation, setApplicationToken} from 'modules/authentication/utils';
import {pathSelector} from 'modules/rootSelectors';
import {doApiCall} from 'modules/sagaUtils';
import {notifyUser} from 'modules/toast/actions';

export function* handleInitialRedirect() {
    console.log('handling initial redirect');

    // allow time to have set the initial state
    yield delay(250);

    // detect existing sessions
    const token = getApiToken();
    if (token) {
        yield handleLoginSuccess();
        return;
    }

    // detect auth redirects
    const authRedirect = yield select(authRedirectSelector);
    if (authRedirect) {
        console.log('authRedirect', authRedirect);
        switch (authRedirect.method) {
            case 'oauth2':
                if (authRedirect.code) {
                    const oauthUsername = yield handleOAuth2Redirect(authRedirect.code);
                    if (oauthUsername) {
                        yield handleLoginSuccess(oauthUsername);
                    } else {
                        yield put(notifyUser('Authentication failed', 'error'));
                        yield handleLogout();
                    }
                    return; // we're done here
                }
                break;
        }
    }

    // get the initial path
    const loginState = yield select(loginStateSelector);
    const url = yield select(pathSelector);

    // and path not equal to /login/
    let doRedirect = loginState != loginStates.LOGGED_IN && !url.startsWith(LOGIN_URL);

    if (doRedirect) {
        console.log('redirecting to the login page');
        rememberLocation(url);
        yield put(redirectTo(LOGIN_URL));
    }
}

export function* newApplicationToken(action) {
    const application = action.payload;
    try {
        const apiAction = yield call(
            doApiCall,
            newAccessToken,
            null,
            {application},
            receiveApplicationToken,
            authenticationError,
        );

        const token = apiAction.payload.data.token;
        const ttl = apiAction.payload.data.ttl;

        setApplicationToken(application, token, ttl);
        yield put(applicationTokenSet())
    } catch (e) {
        console.log('Error getting an application token', application, e);
        yield put(applicationTokenError());
    }
}